// import UserModal from '@/components/UserModal';
import ReactDOM from 'react-dom';
import { start, ubt } from '@zhipu/zprep';
import { message } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import { getDvaApp, history, isBrowser } from 'umi';

import { getUserInfo } from './UserModal';

const { v4: uuidv4 } = require('uuid');

export * from './scaleLinear';
export * from './check';

export * from './UserModal';

// todo 处理 window.open
export const windowOpen = (url: any, ...arg: any[]) => {
  const formatBase = BASE.replace(/\/$/g, '');
  let tempUrl = url;
  if (formatBase && !url.includes('http')) {
    tempUrl = [formatBase, url].join('');
  }
  window.open(tempUrl, ...arg);
};

export function getUrlParams(url: string) {
  // 创建空对象存储参数
  const obj: any = {};

  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url?.split('?')?.[1] || '';

  if (!urlStr) return null;
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split('&');
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split('=');
    obj[arr[0]] = arr[1];
  }
  return obj;
}

// 4, 使用第三方库qs

// =========================== 获取单个数据 ===========================
export const getUrlParam = (query: string, url: string = window.location.href) => {
  return decodeURIComponent(getUrlParams(url)?.[query] || '');
};

export const isObject = (value: any): value is object =>
  value !== null && typeof value === 'object';

export const isFunction = (obj: unknown): obj is (...args: any[]) => any => obj instanceof Function;

export const isString = (value: any): value is string => typeof value === 'string';
export const isBoolean = (value: any): value is boolean => typeof value === 'boolean';
export const isNumber = (value: any): value is number => typeof value === 'number';
export const isUndef = (value: any): value is undefined => typeof value === 'undefined';

export const scrollIntoView = (domID: any, options: any) => {
  const anchorElement = document.getElementById(domID);
  if (anchorElement) {
    anchorElement.scrollIntoView(options);
  }
};
/**
 * 复制文本到剪贴板
 * @param str 要复制的文本
 */
export const copyText = (str: string) => {
  const input = document.createElement('input');
  input.style.cssText = 'opacity: 0;';
  input.type = 'text';
  input.value = str; // 修改文本框的内容
  document.body.appendChild(input);
  input.select(); // 选中文本
  document.execCommand('copy'); // 执行浏览器复制命令
  document.body.removeChild(input);
  message.success('复制成功');
};

const isChina = (s: string) => {
  const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
  if (reg.test(s)) {
    return true;
  }
  return false;
};

export const showDataByQuery = (zh, en) => {
  const query = localStorage.getItem('analysis_currsearches') || '';
  return isChina(query) ? zh || en : en || zh;
};

export const scrollIntoTop = () => {
  document.getElementById('root').scrollIntoView();
};
export const typeList = {
  paper: 'paper',
  patent: 'patent',
  news: 'news',
  fund: 'fund',
  expert: 'expert',
  org: 'org',
};

export const typeList_zh = {
  paper: '论文',
  patent: '专利',
  news: '资讯',
  fund: '项目',
  expert: '学者',
  org: '机构',
};

function mergeSetting(target, source) {
  const innertarget = { ...target };
  const innersource = { ...source };

  // 年 地区 国家
  const { years, countries, orgs, cities, provinces } = innersource;
  if (years) {
    innertarget.year = [years.value, years.label];
    Reflect.deleteProperty(innersource, 'years');
  }
  if (countries) {
    // innertarget.countrys = [...(innertarget.countrys || []), ...countries];
    innertarget.countrys = countries;
    Reflect.deleteProperty(innersource, 'countries');
  }
  if (orgs) {
    // innertarget.orgs = [...(innertarget.orgs || []), ...orgs];
    innertarget.orgs = orgs;
    Reflect.deleteProperty(innersource, 'orgs');
  }
  if (provinces) {
    innertarget.province = provinces;
    Reflect.deleteProperty(innersource, 'provinces');
  }
  if (cities) {
    innertarget.city = cities;
    Reflect.deleteProperty(innersource, 'cities');
  }
  return {
    ...innertarget,
    ...innersource,
  };
}

// 跳转文献列表页
export const onDocumentDetail = (obj, type) => {
  const entries = Object.entries(obj);
  const [key, value] = entries[0];
  if (key === 'searches') {
    localStorage.setItem('documentListSearches', encodeURIComponent(encodeURIComponent(value)));
  }
  const objArr = entries.slice(1);
  const query = objArr
    .map(([key1, value1]) => `${key1}=${encodeURIComponent(encodeURIComponent(value1))}`)
    .join('&');
  windowOpen(
    `documentList/${type}/${key}/${
      key === 'searches' ? 'documentListSearches' : encodeURIComponent(encodeURIComponent(value))
    }?${query}`,
  );
  // window.open(
  //   `documentList/${type}/${key}/${
  //     key === 'searches' ? 'documentListSearches' : encodeURIComponent(encodeURIComponent(value))
  //   }?${query}`,
  // );
};

// 跳转机构详情页
export const onOrgDetail = (id: string) => {
  window.open(`https://www.aminer.cn/institution/${id}`);
};

// 跳转学者详情页
export const onExpertDetail = (id) => {
  window.open(`https://www.aminer.cn/profile/-/${id}`);
  // window.open(`detail/profile/${id}`);
};

// 跳转论文详情页
export const onPubDetail = (id: string) => {
  window.open(`https://www.aminer.cn/pub/${id}`);
};

// 跳转专利详情页
export const onPatentDetail = (id: string) => {
  // window.open(`detail/patent/${id}`);
  windowOpen(`detail/patent/${id}`);
};
// &s=${searcher}

interface IKeyword {
  label: string;
  value: string;
}

interface IQuery {
  q?: {
    searcher?: string; //检索式，必选
    source?: string; // 数据库类别
    matchFields?: any; // 匹配字段，默认标题+摘要+关键字
    domains?: string; // 学科分类，可选
    conferences?: string; //会议，可选
    citationRange?: string; // 论文被引量，必选
    pubbaseType?: string; //数据来源，必选
    start_year?: string; //开始时间，与结束时间限定查询时间范围，如果years同时存在，以years作为优先查询条件
    end_year?: string; //结束时间，
    //
    authorIds?: IKeyword[]; //论文作者，可选
    years?: IKeyword | IKeyword[]; //发表时间，建议更改为范围，可选
    countries?: IKeyword[]; //论文地区，可选
    author_countries?: IKeyword[]; //论文地区，可选
    org_countries?: IKeyword[]; //论文地区，可选
    orgs?: IKeyword[]; //论文机构，可选
    keywords?: IKeyword[]; //固定关键词搜素，可选
    coAuthorIds?: IKeyword[]; // 合作学者
    provinces?: IKeyword[]; //论文省份，可选
    cities?: IKeyword[];
    co_orgs?: IKeyword[]; // 合作机构
    co_countries?: IKeyword[]; // 合作机构
    co_provinces?: IKeyword[];
    co_cities?: IKeyword[];
  };
  [key: string]: any;
}

// 跳转文献列表页面
export function onListDetail(_query: IQuery) {
  const { q: querySetting, t, d, f, ...query } = _query;
  let queryArr = [];

  let analysis_content_type = '';
  if (query) {
    for (const key in query) {
      const value = query[key]; //埋点数据
      if (key == 'analysis_content_type') {
        analysis_content_type = value;
      }
      queryArr.push(`${key}=${encodeURI(key === 'o' ? JSON.stringify(value) : value)}`);
    }
  }

  const s = getUrlParam('searcher');
  const r = getUrlParam('r');
  if (f) {
    queryArr.push(`f=${f}`);
  }
  if (s) {
    queryArr.push(`searcher=${s}`);
  }

  if (r) {
    queryArr.push(`r=${r}`);
  }

  const queryString = queryArr.join('&');
  if (analysis_content_type) {
    // 数据埋点
    const tbObj = {
      analysis_content_type,
      search_content: getSearchTile(),
      graph_node_content: queryString,
    };

    ubtEvent({
      // 数据埋点
      ubt_key: 'chart_node',
      ...tbObj,
    });
  }

  // 跳转文献列表页
  const trendSetting = getDvaApp()._store.getState().trend.setting;
  let queryArr1 = [];
  if (f) {
    queryArr1.push(`f=${f}`);
  }
  if (t) {
    queryArr1.push(`t=${encodeURI(t)}`);
  }
  if (d) {
    queryArr1.push(`d=${encodeURI(d)}`);
  }
  if (r) {
    queryArr1.push(`r=${r}`);
  }
  const queryString1 = queryArr1.join('&');
  sessionStorage.setItem(
    'trendSetting',
    JSON.stringify(mergeSetting(trendSetting, querySetting) || {}),
  );
  window.open(`${process.env.publicPath}/list?${queryString1}`);
  setTimeout(() => {
    sessionStorage.removeItem('trendSetting');
  }, 300);
}

// 防抖
export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let timeoutId: NodeJS.Timeout;

  return function debouncedFn(...args: Parameters<T>): void {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// 节流函数
export function throttle<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let lastExecTime = 0;
  let timeoutId: NodeJS.Timeout | null = null;

  return function throttledFn(...args: Parameters<T>): void {
    const currentTime = Date.now();

    if (!lastExecTime || currentTime - lastExecTime >= delay) {
      lastExecTime = currentTime;
      func.apply(this, args);
    } else if (!timeoutId) {
      timeoutId = setTimeout(() => {
        lastExecTime = currentTime;
        func.apply(this, args);
        timeoutId = null;
      }, delay - (currentTime - lastExecTime));
    }
  };
}

export function checkOs() {
  const { userAgent } = navigator || {};
  let type = 'Windows';
  const osOBj = {
    Windows: 'Windows',
    Mac: 'Mac',
    Linux: 'Lunix',
    X11: 'Unix',
  };
  Object.keys(osOBj).forEach((item) => {
    const value = osOBj[item];
    if (userAgent.indexOf(item, 0) != -1) {
      type = value;
      return type;
    }
  });

  return type;
}

// 获取 API
export const getAPIPrefix = (url: string = '') => {
  // 全路径直接放行
  if (url.includes('http://') || url.includes('https://')) {
    return url;
  }

  // todo 添加生产环境信息
  const urlPreObj = {
    test: 'https://trend-beta.aminer.cn/microtrend-api',
    prod: 'https://trend.aminer.cn/microtrend-api',
  };
  return `${urlPreObj[REACT_APP_ENV]}${url}`;
};

// 是否浏览器端
export const isBrowserClient = () => {
  return Boolean(isBrowser && isBrowser());
};

// 获取 Localstorage
export const getLocalStorageByKey = (key: string = '', value: string = '') => {
  let result = value;
  if (isBrowserClient()) {
    result = localStorage.getItem(key) || result;
  }
  return result;
};

// 获取当前用户访问IP
export const getUserIp_Id = () => {
  return {
    userIp: getLocalStorageByKey('USER_IP', '127.0.0.1'),
  };
};

export function watchPageVisibility(onHidden?: () => void, onVisible?: () => void) {
  const visibilityChangeProperty =
    'hidden' in document
      ? 'visibilitychange'
      : 'webkitHidden' in document
      ? 'webkitvisibilitychange'
      : null;

  if (visibilityChangeProperty !== null) {
    document.addEventListener(visibilityChangeProperty, function () {
      if (document.hidden || document.webkitHidden) {
        // 页面被隐藏
        if (typeof onHidden === 'function') {
          onHidden();
        }
      } else {
        // 页面被显示
        if (typeof onVisible === 'function') {
          onVisible();
        }
      }
    });
  } else {
    // 不支持 Page Visibility API
    console.log('当前浏览器不支持 Page Visibility API');
  }
}

// 获取枚举 key
export const getEnumValueArr = (value: any) => {
  const result = Object.values(value);
  return Object.values(value);
};

// 获取枚举 value
export const getEnumKeyArr = (value: any) => {
  const key = Object.keys(value).map((item: string) => parseInt(item, 10) * 1);
  // console.log("key",)
  return Object.keys(value).map((item: string) => item * 1);
};

//  value 和 key 取反
export const getMapValueArr = (map: any) => {
  return [...map.values()];
};

//  value 和 key 取反
export const getMapKeyArr = (map: any) => {
  return [...map.keys()].map((item) => parseInt(item));
};

// 邮箱加星
export const formatEmailAddStar = (email: any) => {
  return email.replace(/^(.{3}).*(?=(.{0,3}@))/, (match: any, captureGroup: any) => {
    return captureGroup + '*'.repeat(3);
  });
};

// 手机加星
export const formatPhoneAddStar = (mobile: any) => {
  return mobile.substr(-11).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};

/**
 *  value YYYY-MM-DD
 * @param value 判断到期时间
 * @returns
 */
export const permissionLeftDetail = (
  expireTime: string, //免费的过期时间
  payTime: string, //个人过期时间
  orgEXpireTime: string, //机构过期时间
  isBindOrg: number,
) => {
  //console.log('总过期时间',expireTime,'付费时间',payTime,'机构过期时间',orgEXpireTime,'是否绑定机构',isBindOrg,);
  let orgLeft = moment(orgEXpireTime, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') + 1;

  // 已绑定机构
  let payLeft = moment(payTime, 'YYYY-MM-DD').diff(moment(orgEXpireTime, 'YYYY-MM-DD'), 'days');
  // 未绑定机构或者已绑定机构但是机构过期了
  if (isBindOrg !== 1 || (isBindOrg == 1 && orgLeft < 0)) {
    payLeft = moment(payTime, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') + 1;
  }

  // 付费未过期
  let freeLeft = moment(expireTime, 'YYYY-MM-DD').diff(moment(payTime, 'YYYY-MM-DD'), 'days');
  if (payLeft < 0) {
    freeLeft = moment(expireTime, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') + 1;
  }

  // 过期了则全部为0
  if (moment(expireTime, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') + 1 < 0) {
    orgLeft = 0;
    payLeft = 0;
    freeLeft = 0;
  }

  return {
    机构付费: { remaining: orgLeft, deadline: orgEXpireTime },
    个人付费: { remaining: payLeft, deadline: payTime },
    免费试用: { remaining: freeLeft, deadline: expireTime },
    orgPay: { remaining: orgLeft, deadline: orgEXpireTime },
    personPay: { remaining: payLeft, deadline: payTime },
    zeroPay: { remaining: freeLeft, deadline: expireTime },
  };
};

// 当前用户使用权限和到期 数据
export const handlerCurPayInfo = (result: any) => {
  // 机构付费
  const userInfo = getUserInfo();
  if (userInfo?.is_bind_org == 1 && result?.orgPay?.remaining > 0) {
    return {
      type: '机构付费',
      remaining: result?.orgPay?.remaining,
      deadline: result?.orgPay?.deadline,
    };
  }
  // 个人付费
  if (result?.personPay.remaining > 0) {
    return {
      type: '个人付费',
      remaining: result?.personPay?.remaining,
      deadline: result?.personPay?.deadline,
    };
  }
  // 免费试用
  return {
    type: '免费试用',
    remaining: result?.zeroPay?.remaining,
    deadline: result?.zeroPay?.deadline,
  };
};

// 当前用户到期时间
export const sumRemainingFunc = (param: any) => {
  const { orgPay, personPay, zeroPay } = param;
  const remArr = [orgPay.remaining, personPay.remaining, zeroPay.remaining].filter(
    (item) => item >= 0,
  );
  return [...remArr].reduce((prev, cur) => prev + cur);
};

// 基于表单单set预览列表
export const getPtLabelValue = (properties: any) => {
  return Object.entries(properties).map((item: any) => {
    return {
      label: item[1].title,
      value: item[1].displayValue || item[1].default,
    };
  });
};

// 获取token
export function getLocalFetchStatus() {
  let fetchStatus = localStorage?.getItem('global_glm_fetch_status');
  return fetchStatus == 'true' ? true : false;
}

// 获取token
export function setLocalFetchStatus(value: any) {
  localStorage?.setItem('global_glm_fetch_status', value);
}

const pageParamObj = {
  search_analysis_sim: {
    // 简单搜索
    event_type: 'search_analysis',
    event_desc: '点击「检索」按钮',
    search_type: '简单检索',
  },
  search_analysis_senior: {
    // 高级搜
    event_type: 'search_analysis',
    event_desc: '点击「分析」按钮 ',
    search_type: '简单检索',
  },

  search_analysis: {
    event_type: 'search_analysis',
    event_desc: '点击「分析」按钮',
    // search_type: '简单检索',
  },
  search_search: {
    event_type: 'search_search',
    event_desc: '点击「检索」按钮',
    // search_type: '简单检索',
  },
  search_advanced: {
    event_type: 'search_advanced',
    event_desc: '点击「高级检索」按钮',
  },
  select_search_associated_words: {
    event_type: 'select_search_associated_words',
    event_desc: '选择搜索联想词',
  },
  view_all_history_record: {
    event_type: 'view_all_history_record',
    event_desc: '点击「查看全部检索记录」按钮',
  },

  ai_gerenate_searchs: {
    event_type: 'ai_gerenate_searchs',
    event_desc: '点击「生成检索式」按钮或「停止生成」按钮',
  },

  search_copy: {
    event_type: 'search_copy',
    event_desc: '复制检索式按钮',
  },

  // 首页
  tech_tree_node: {
    event_type: 'tech_tree_node',
    event_desc: '点击技术树节点',
  },
  AI_genrate_search: {
    event_type: 'AI_genrate_search',
    event_desc: '点击「生成检索式」按钮',
  },
  tech_tab_name: {
    event_type: 'tech_tab_name',
    event_desc: '点击技术树tab',
  },
  tech_tab_name_all: {
    event_type: 'tech_tab_name_all',
    event_desc: '点击热门分析领域标签',
  },
  tech_graph_name: {
    event_type: 'tech_graph_name',
    event_desc: '点击热门分析图表',
  },
  view_news: {
    event_type: 'view_news',
    event_desc: '点击产业动态资讯名称查看资讯详情',
  },
  view_all_news: {
    event_type: 'view_all_news',
    event_desc: '点击产业动态【查看全部】按钮',
  },
  view_tech_tree: {
    event_type: 'view_tech_tree',
    event_desc: '点击技术树名称跳转到技术全景分析页',
  },

  tech_tab_name_hot: {
    event_type: 'tech_tab_name_hot',
    event_desc: '点击技术树tab热点',
  },
  tech_tab_name_new: {
    event_type: 'tech_tab_name_new',
    event_desc: '点击技术树tab最新',
  },
  tech_tab_name_my: {
    event_type: 'tech_tab_name_my',
  },

  view_all: {
    event_type: 'view_all',
    event_desc: '点击【查看全部】按钮',
  },
  view_tech: {
    // 图标
    event_type: 'view_tech',
    event_desc: '点击图表',
  },
  view_tech_desc: {
    // 技术详情
    event_type: 'view_tech',
    event_desc: '点击图表或「查看完整分析内容」查看技术分析详情',
  },

  view_paper: {
    event_type: 'view_paper',
    event_desc: '点击论文名称查看论文详情',
  },

  view_scholar: {
    event_type: 'view_scholar',
    event_desc: '点击学者姓名查看学者详情',
  },
  view_organization: {
    event_type: 'view_organization',
    event_desc: '点击机构名称查看机构详情',
  },

  search_history_sim: {
    //  简单检索历史记录
    event_type: 'search_history',
    event_desc: '点击「简单检索历史记录」按钮',
    search_type: '简单检索',
  },
  search_history_senior: {
    // 高级检索历史记录
    event_type: 'search_history',
    event_desc: '点击「高级检索历史记录」',
    search_type: '高级检索',
  },
  search_history_ana: {
    // 高级检索历史记录-检索分析
    event_type: 'search_history',
    event_desc: '点击「高级检索历史记录-检索分析」按钮',
    search_type: '高级检索',
  },
  advance_search_history_fill: {
    event_type: 'advance_search_history_fill',
    event_desc: '点击「填充检索式」按钮',
  },

  // 技术分析

  select_filter_criteria: {
    event_type: 'select_filter_criteria',
    event_desc: '选择筛选条件',
  },
  clear_filter_criteria: {
    event_type: 'clear_filter_criteria',
    event_desc: '删除单个筛选条件',
  },
  clear_all_filter_criteria: {
    event_type: 'clear_all_filter_criteria',
    event_desc: '清空所有筛选条件',
  },

  generate_tech_word: {
    event_type: 'generate_tech_word',
    event_desc: '生成技术词解释',
  },
  regenerate_tech_word: {
    event_type: 'regenerate_tech_word',
    event_desc: '重新生成技术词解释',
  },
  generate_chart_interpretation: {
    event_type: 'generate_chart_interpretation',
    event_desc: '点击「AI生成图表解读」按钮',
  },
  regenerate_chart_interpretation: {
    event_type: 'regenerate_chart_interpretation',
    event_desc: '点击图表解读「重新生成」按钮',
  },

  analysis_help_Instructions: {
    event_type: 'analysis_help_Instructions',
    event_desc: '点击「使用说明」标签',
  },

  full_screen_display: {
    event_type: 'full_screen_display',
    event_desc: '点击「展示全屏」按钮',
  },

  download_chart: {
    event_type: 'download_chart',
    event_desc: '下载图表',
  },

  switch_cn_en: {
    event_type: 'switch_cn_en',
    event_desc: '切换中英文',
  },

  switch_chart_style: {
    event_type: 'switch_chart_style',
    event_desc: '切换图表样式',
  },

  chart_node: {
    event_type: 'chart_node',
    event_desc: '点击图表中的节点查看文献列表',
  },
  data_overview_number: {
    event_type: 'data_overview_number',
    event_desc: '点击数据概览处「论文数量」、「学者数量」和「机构数量」按钮',
  },

  // 文献列表
  data_tab: {
    event_type: 'data_tab',
    event_desc: '点击文献列表页签',
  },
  data_tab_sort_order: {
    event_type: 'data_tab_sort_order',
    event_desc: '点击文献列表排序方式',
  },

  // view_translate_paper: {
  //   event_type: 'view_translate_paper',
  //   event_desc: '点击论文列表中的查看译文',
  // },
  // analysis_content_regenerate: {
  //   event_type: 'analysis_content_regenerate',
  //   event_desc: '点击文献翻译「重新生成」按钮',
  // },

  // 导航+快捷操作
  navigator_platform_icon: {
    // page_name: '顶部导航',
    event_type: 'navigator_platform_icon',
    event_desc: '点击顶部导航「知因图标」',
  },

  navigator_homepage_button: {
    // page_name: '顶部导航',
    event_type: 'navigator_homepage_button',
    event_desc: '点击顶部导航「首页」按钮',
  },

  navigator_search_button: {
    // page_name: '顶部导航',
    event_type: 'navigator_search_button',
    event_desc: '点击顶部导航「搜索」按钮',
  },

  navigator_vip_button: {
    // page_name: '顶部导航',
    event_type: 'navigator_vip_button',
    event_desc: '点击顶部导航「开通会员」按钮',
  },

  navigator_personal_centor_button: {
    // page_name: '顶部导航',
    event_type: 'navigator_personal_centor_button',
    event_desc: '点击顶部导航「个人中心」按钮',
  },

  navigator_sign_out_button: {
    // page_name: '顶部导航',
    event_type: 'navigator_sign_out_button',
    event_desc: '点击顶部导航「退出登录」按钮',
  },

  navigator_user_feedback: {
    // page_name: '快捷操作栏',
    event_type: 'navigator_user_feedback',
    event_desc: '点击快捷操作栏「用户反馈」按钮',
  },

  navigator_help_centor: {
    // page_name: '快捷操作栏',
    event_type: 'navigator_help_centor',
    event_desc: '点击快捷操作栏「帮助中心」按钮',
  },

  // 会员页面
  activate_vip_membership: {
    // page_name: '快捷操作栏',
    event_type: 'activate_vip_membership',
    event_desc: '点击开通会员按钮',
  },

  // 个人中心-分析报告页面
  download_report: {
    page_name: '个人中心-分析报告',
    event_type: 'download_report',
    event_desc: '点击「下载报告」按钮',
  },

  regenerate_report: {
    page_name: '个人中心-分析报告',
    event_type: 'regenerate_report',
    event_desc: '点击「重新生成报告」按钮',
  },

  delete_report_record: {
    page_name: '个人中心-分析报告',
    event_type: 'delete_report_record',
    event_desc: '点击删除报告确认弹窗「确定」按钮',
  },

  data_page_number: {
    page_name: '个人中心-分析报告',
    event_type: 'data_page_number',
    event_desc: '点击分页页码',
  },

  // 个人中心-检索记录
  search_history_person: {
    //  简单检索历史记录
    page_name: '个人中心-检索记录',
    event_type: 'search_history',
    event_desc: '点击检索记录信息卡片',
  },

  clear_all_history_record: {
    page_name: '个人中心-检索记录',
    event_type: 'clear_all_history_record',
    event_desc: '点击清空记录确认弹窗「确定」按钮',
  },
  delete_history_record: {
    page_name: '个人中心-检索记录',
    event_type: 'delete_history_record',
    event_desc: '点击删除记录确认弹窗「确定」按钮',
  },
  data_page_number_person: {
    page_name: '个人中心-检索记录',
    event_type: 'data_page_number',
    event_desc: '点击分页页码',
  },
  industry_information_page_tab: {
    page_name: '产业资讯页',
    event_type: 'page_tab',
    event_desc: '点击「订阅」页 和「推荐」页签',
  },
  //  industry_tab
  industry_information_industry_tab: {
    page_name: '产业资讯页',
    event_type: 'industry_tab',
    event_desc: '点击产业名称标签',
  },
  industry_information_data_tab: {
    page_name: '产业资讯页',
    event_type: 'data_tab',
    event_desc: '点击文献列表页签',
  },
  industry_information_view_news: {
    page_name: '产业资讯页',
    event_type: 'view_news',
    event_desc: '点击资讯名称查看资讯详情',
  },
  industry_information_view_paper: {
    page_name: '产业资讯页',
    event_type: 'view_paper',
    event_desc: '点击论文名称查看论文详情',
  },
  industry_information_data_page_number: {
    page_name: '产业资讯页',
    event_type: 'data_page_number',
    event_desc: '点击分页页码',
  },
  industry_information_subscription_set: {
    page_name: '产业资讯页',
    event_type: 'subscription_set',
    event_desc: '点击顶部「添加订阅」按钮、「管理订阅」按钮、订阅页面「立即订阅」按钮',
  },
  industry_information_subscription_set_confirm: {
    page_name: '产业资讯页',
    event_type: 'subscription_set_confirm',
    event_desc: '点击订阅配置弹窗的「确定」按钮',
  },
  industry_information_search_news: {
    page_name: '产业资讯页',
    event_type: 'search_news',
    event_desc: '触发搜索操作',
  },
  industry_information_generate_summary: {
    page_name: '产业资讯页',
    event_type: 'generate_summary',
    event_desc: '点击「生成简报」按钮',
  },

  industry_information_generate_summary_confirm: {
    page_name: '产业资讯页',
    event_type: 'generate_summary_confirm',
    event_desc: '点击简报配置弹窗内的「生成简报」按钮',
  },
  industry_information_add_summary_news: {
    page_name: '产业资讯页',
    event_type: 'add_summary_news',
    event_desc: '点击资讯列表「添加到简报」按钮',
  },
  industry_information_add_summary_paper: {
    page_name: '产业资讯页',
    event_type: 'add_summary_paper',
    event_desc: '点击论文列表「添加到简报」按钮',
  },
  fxbg_data_page_number: {
    page_name: '个人中心-分析报告',
    event_type: 'data_page_number',
    event_desc: '点击分页页码',
  },
  fxbg_regenerate_news_brief_report: {
    page_name: '个人中心-分析报告',
    event_type: 'regenerate_news_brief_report',
    event_desc: '点击「重新生成简报」按钮',
  },
  fxbg_delete_news_brief_report: {
    page_name: '个人中心-分析报告',
    event_type: 'delete_news_brief_report',
    event_desc: '点击删除简报确认弹窗「确定」按钮',
  },
  order_orders_invoice_button: {
    page_name: '个人中心_我的订单',
    event_type: 'orders_invoice_button',
    event_desc: '点击「开发票」按钮',
  },

  // 高级检索页面
  select_search_field: {
    event_type: 'select_search_field',
    event_desc: '选择字段列表中的字段',
  },
  select_search_logical: {
    event_type: 'select_search_logical',
    event_desc: '选择逻辑连接词',
  },
  select_search_vague_precise: {
    event_type: 'select_search_vague_precise',
    event_desc: '选择「模糊」和「精确」',
  },
  add_search_field: {
    event_type: 'add_search_field',
    event_desc: '点击「+」按钮，添加字段输入框',
  },
  delete_search_field: {
    event_type: 'delete_search_field',
    event_desc: '点击「—」按钮，删除字段输入框',
  },
  search_clear_all: {
    event_type: 'search_clear_all',
    event_desc: '点击「清空检索式」按钮',
  },
  search_shotcut_key: {
    event_type: 'search_shotcut_key',
    event_desc: '点击「快捷键」按钮',
  },
  search_help_instructions: {
    event_type: 'search_help_instructions',
    event_desc: '点击「检索式使用说明」按钮',
  },
  experience_ai_generate_query: {
    event_type: 'experience_ai_generate_query',
    event_desc: '点击「体验AI生成检索式」按钮',
  },
  return_advanced_search: {
    event_type: 'return_advanced_search',
    event_desc: '点击「返回」按钮',
  },
  nav_tree_tab_name: {
    event_type: 'nav_tree_tab_name',
    event_desc: '点击侧边导航技术树名称',
  },
  export_data: {
    event_type: 'export_data',
    event_desc: '点击导出数据按钮',
  },
  export_data_confirm: {
    event_type: 'export_data_confirm',
    event_desc: '点击导出数据弹窗「导出」按钮',
  },
  generate_overview: {
    event_type: 'generate_overview',
    event_desc: '点击「生成综述」按钮',
  },
  generate_overview_confirm: {
    event_type: 'generate_overview_confirm',
    event_desc: '点击生成综述弹窗「生成综述」按钮',
  },
  regenerate_overview: {
    event_type: 'regenerate_overview',
    event_desc: '重新生成综述',
  },
};

type ubtEventParams = {
  ubt_key?: keyof typeof pageParamObj;
  [key: string]: any;
};

/**
 * action
 * @params event 必填 事件类型, 英文标识（大驼峰命名）
 * @params event_desc 必填 事件描述， pageView、pageExit使用时可为null
 * @params data 必填，至少要有用户信息
 * */
const pageObj = {
  '/': '首页',
  '/vip': '开通会员页',
  '/list': '文献列表',
  '/ana': '技术分析页',
  '/dynamic': '产品资讯页',
  '/user/info': '个人中心-我的信息',
  '/user/record': '个人中心-检索记录',
  '/user/report': '个人中心-分析报告',
  '/user/order': '个人中心-我的订单',
  '/advancedsearch': '高级检索页',
  '/instructions': '使用说明页',
};

export function ubtEvent(param: ubtEventParams) {
  const { event_type, event_desc, ubt_key, user_name, ...rest } = param;
  const user = getUserInfo();

  const pathName = history?.location?.pathname;

  const pageData = pageParamObj[ubt_key];

  // 取值分别为普通用户、个人免费VIP、个人付费VIP、机构付费VIP。某个用户同时具有多种VIP类型时，传一个VIP类型list

  // user_vip_type
  // user_source_channel
  // event_time
  let user_source_channel = ''; // 来源渠道
  if (document.referrer) {
    user_source_channel = document?.referrer?.match(/:\/\/(.[^/]+)/)[1];
  }
  const user_vip_type = getVipType();
  const event_time = moment().format('YYYY-MM-DD HH:mm:ss');

  const pathname = pathName.includes('/analysis') ? pathName.replace('/analysis', '') : pathName;

  let trackData = {
    page_name: pageObj[pathname] || '首页',
    page_env: REACT_APP_ENV,
    user_id: user?.userId,
    user_name: user?.name || user_name,
    event_time,
    user_source_channel,
    user_vip_type,
    ...rest,
    ...pageData,
  };

  const tech_node_name = getGlobalAttr('tech_node_name');
  const tech_tree_name = getGlobalAttr('tech_tree_name');

  // 需要  tech_node_name，tech_tree_name 的事件
  const treeNodeEventArr = [
    'tech_tree_node',
    'view_all',
    'view_tech',
    'view_paper',
    'view_scholar',
    'view_organization',
  ];

  if (treeNodeEventArr.includes(event_type || ubt_key)) {
    trackData['tech_node_name'] = tech_node_name;
    trackData['tech_tree_name'] = tech_tree_name;
  }

  ubt.event(event_type || trackData.event_type, event_desc || trackData.event_desc, trackData);
}
export function accessEvent(type: 'AnnoQueryEnter' | 'AnnoQueryExit', params: any) {
  const user = getUserInfo();
  const param = {
    user_id: user?.userId,
    user_name: user?.name,
    page_env: REACT_APP_ENV,
    ...params,
  };
  try {
    if (type == 'AnnoQueryEnter') {
      // console.log('进去', param);
      ubt.pageView('AnnoQueryEnter', null, param);
    } else {
      // console.log('离开', param);
      ubt.pageExit('AnnoQueryExit', null, param);
    }
  } catch (error) {}
}

// 获取查询title
export function getSearchTile() {
  const res = getDvaApp()._store;
  const { trend } = res.getState();
  return trend?.searcher;
}

// 获取vip 类型
export function getVipType() {
  // 取值分别为普通用户、个人免费VIP、个人付费VIP、机构付费VIP。某个用户同时具有多种VIP类型时，传一个VIP类型list
  const userInfo = getUserInfo();
  let result = [];
  if (userInfo) {
    // pay_time 个人到期时间
    // orgExpireTime 机构到期时间
    // expire_time 到期时间
    const { system_time, expire_time, pay_time, orgExpireTime } = userInfo;

    let orgNum =
      moment(orgExpireTime, 'YYYY-MM-DD').diff(moment(system_time, 'YYYY-MM-DD'), 'days') + 1;
    let payNum = moment(pay_time, 'YYYY-MM-DD').diff(moment(system_time, 'YYYY-MM-DD'), 'days') + 1;
    let expireNum =
      moment(expire_time, 'YYYY-MM-DD').diff(moment(system_time, 'YYYY-MM-DD'), 'days') + 1;

    // 机构付费VIP
    if (orgNum > 0) {
      result.push('机构付费VIP');
    }
    // 个人付费VIP
    if (payNum > 0) {
      result.push('个人付费VIP');
    }
    // 个人免费VIP
    if (expireNum > 0) {
      result.push('个人免费VIP');
    }
    // 普通用户
    if (orgNum <= 0 && payNum <= 0 && expireNum <= 0) {
      result.push('普通用户');
    }
  }
  return result;
}

// 设置全局属性
export function setGlobalAttr(key: any, value: any) {
  window[key] = value;
}

// 设置全局属性
export function getGlobalAttr(key: any) {
  return window[key];
}

// 设置报告的封面地址
export function reportImg(id: any) {
  return `${
    REACT_APP_ENV == 'test' ? 'https://trend-beta.aminer.cn' : 'https://trend.aminer.cn'
  }/report-doc/${id}/thumb.png`;
}

export function elementsContains(
  elements: (HTMLElement | undefined | null)[],
  target: HTMLElement,
) {
  return elements.some((ele) => ele && ele.contains(target));
}

export const getSearchTime = () => {
  if (dayjs().month() + 1 < 4) {
    return {
      start_year: dayjs().year() - 20,
      end_year: dayjs().year() - 1,
    };
  }

  return {
    start_year: dayjs().year() - 19,
    end_year: dayjs().year(),
  };
};

function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  const buffer = new ArrayBuffer(byteString.length);
  const dataArray = new Uint8Array(buffer);
  for (let i = 0; i < byteString.length; i++) {
    dataArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([buffer], { type: mimeString });
}

export function uploadBase64(base64Str: string, fileName: string) {
  const blob = dataURItoBlob(base64Str);

  const formData = new FormData();
  formData.append('file', blob, fileName || 'filename.png'); // 这里的'file'是服务器期望的键，'filename.png'是上传的文件名
  return formData;
}

type SingletonFetchConfig = {
  loading: boolean;
  stack: ((isSuccess: boolean, data: any) => void)[];
  data: any | null;
  index: number;
  clearData: () => void;
};

export function singletonFetch(fetchFunction: (...args: any[]) => Promise<any>) {
  const CONFIG: SingletonFetchConfig = {
    loading: false,
    stack: [],
    data: null,
    index: 0,
    clearData() {
      CONFIG.data = null;
      CONFIG.loading = false;
      // CONFIG.index++;
      CONFIG.stack = [];
    },
  };

  async function fetchData(...args: any[]) {
    if (CONFIG.loading) {
      return new Promise((resolve, reject) => {
        CONFIG.stack.push((isSuccess: boolean, data: any) => {
          if (isSuccess) {
            resolve(data);
          } else {
            reject(data);
          }
        });
      });
    }

    // 直接返回数据
    if (CONFIG.data) {
      return CONFIG.data;
    }

    CONFIG.loading = true;
    // CONFIG.index++;
    // let currentIndex = CONFIG.index;
    try {
      const data = await fetchFunction(...args);
      // if (currentIndex !== CONFIG.index) return new Promise((resolve) => {});
      CONFIG.stack.forEach((fn) => fn(true, data));
      CONFIG.data = data;
      CONFIG.loading = false;
      CONFIG.stack = [];
      return data;
    } catch (error) {
      // if (currentIndex !== CONFIG.index) return new Promise((resolve) => {});
      CONFIG.stack.forEach((fn) => fn(false, error));
      CONFIG.loading = false;
      CONFIG.stack = [];
      // throw new Error(error);
      throw error;
    }
  }

  fetchData.clearData = CONFIG.clearData;

  return fetchData;
}

export function formatNum(nums) {
  if (!nums) return '0';
  const num = nums.replace('.', '');
  const [pre, last] = [+num.slice(0, 3), num.slice(3)];
  const numss = pre + '.' + last;
  let res0 = Number(numss).toFixed(2);
  let res = +res0;
  if (res === 0) {
    for (let i = 2; i < last.length; i++) {
      const e = last[i];
      res0 += e;
      if (e !== '0') {
        break;
      }
    }
    return res0;
  } else {
    return res;
  }
}
export const deepCopyObj = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};

export const getWeekDayList = () => {
  return [
    { value: '1', label: '每周一' },
    { value: '2', label: '每周二' },
    { value: '3', label: '每周三' },
    { value: '4', label: '每周四' },
    { value: '5', label: '每周五' },
    { value: '6', label: '每周六' },
    { value: '7', label: '每周日' },
  ];
};

export const getMonthDayList = () => {
  const arr = Array(28).fill(1);
  const temp = arr.map((item: any, index: any) => {
    return { value: (index + 1).toString(), label: `每月${index + 1}日` };
  });
  return temp;
};

// 新闻日期格式化
export const formatNewsHours = (date: any) => {
  if (!date) return '';
  const endDay = moment();
  const startDay = moment(date);
  const hoursDiff = endDay.diff(startDay, 'hours');
  return 48 >= hoursDiff;
};

// 新闻日期格式化
export const formatNewsTime = (date: any) => {
  if (!date) return '';

  const endDay = moment();
  const startDay = moment(date);

  // // 1. 发布日期在1小时以内时，统一换算成“X分钟前”；
  const minutesDiff = endDay.diff(startDay, 'minutes');
  if (60 >= minutesDiff) {
    return `${minutesDiff}分钟前`;
  }
  // 2. 发布日期在1小时-48小时以内时，统一换算成“X小时前”；
  const hoursDiff = endDay.diff(startDay, 'hours');
  if (1 <= hoursDiff && 48 >= hoursDiff) {
    return `${hoursDiff}小时前`;
  }
  // 3. 发布日期在3-7天时，统一换成“X天前”；
  const dayDiff = endDay.diff(startDay, 'days');
  if (2 <= dayDiff && 7 >= dayDiff) {
    return `${dayDiff}天前`;
  }

  // 4. 发布日期在7天以外时，直接写日期，格式为“YYYY-MM-DD”，精确到日
  return moment(date).format('YYYY-MM-DD');
};

export const truePath = (path: string) => {
  // 返回的都是trendpath 测试环境要自动返回为trend-beta
  if (REACT_APP_ENV == 'test') {
    return path.replace('trend', 'trend-beta');
  } else {
    return path;
  }
};

// 字符串格式化成年
export const getFormatYear = (date: string) => {
  console.log('==>>>>', moment(date).format('YYYY'));
  return moment(date).format('YYYY');
};

/**
 * 生成随机id
 * @returns {string}
 */
export const uuid = () => uuidv4();

export const Portal = ({ children }) => {
  return typeof document === 'object' ? ReactDOM.createPortal(children, document.body) : null;
};
export function getBrowserInfo() {
  let ua = navigator.userAgent;
  let browser = '';

  if (ua.indexOf('Firefox') > -1) {
    browser = 'Firefox';
  } else if (ua.indexOf('Chrome') > -1) {
    browser = 'Chrome';
  } else if (ua.indexOf('Safari') > -1) {
    browser = 'Safari';
  } else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) {
    browser = 'Internet Explorer';
  } else if (ua.indexOf('Edge') > -1) {
    browser = 'Edge';
  } else if (ua.indexOf('Opera') > -1) {
    browser = 'Opera';
  }

  return browser;
}

export function renameKeys(obj, newKeys) {
  return Object.entries(newKeys).reduce(
    (pre, [oldKey, newKey]) => {
      if (pre[oldKey]) {
        pre[newKey] = pre[oldKey];
        delete pre[oldKey];
      }
      return pre;
    },
    { ...obj },
  );
}
